import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
const faqs = [{
  question: 'Are online degrees respected by employers?',
  answer: 'Yes. Employers increasingly view online degrees from accredited institutions exactly the same as traditional on-campus degrees. What matters most to employers is the accreditation of the school and the skills you acquire, not the medium of instruction.'
}, {
  question: 'How do I know if a school is accredited?',
  answer: "We only partner with schools that hold regional or national accreditation recognized by the U.S. Department of Education. You can verify a school's accreditation status on their website or through the Database of Accredited Postsecondary Institutions and Programs."
}, {
  question: 'Can I get financial aid for an online degree?',
  answer: 'Yes. Students enrolled in accredited online degree programs are generally eligible for the same federal financial aid (grants and loans) as on-campus students. You will need to complete the Free Application for Federal Student Aid (FAFSA) to determine your eligibility.'
}, {
  question: 'How much does this matching service cost?',
  answer: 'Our matching service costs students nothing. We are compensated by our partner schools when we connect them with prospective students, which allows us to provide this resource at no cost to you.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-16 bg-warm border-t border-gray-200" data-id="element-214" data-mp="2oegcwyftixz7">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-215" data-mp="2odngorehjqvb">
        <div className="text-center mb-10" data-id="element-216" data-mp="2jf3qgesuzsx5">
          <h2 className="text-3xl font-bold text-navy mb-4" data-id="element-217" data-mp="2jd95j0hl80t2">
            Frequently Asked Questions
          </h2>
          <p className="text-gray-600" data-id="element-218" data-mp="p1cayynumets">
            Common questions about online education and our service.
          </p>
        </div>

        <div className="space-y-4" data-id="element-219" data-mp="2p4dfdtsna91f">
          {faqs.map((faq, index) => <div key={index} className="bg-white border border-gray-200 rounded-lg overflow-hidden shadow-sm transition-all duration-200" data-id="element-220" data-mp="2u2nf8hpbdxtd" data-mpi={index}>
              <button className="w-full px-6 py-4 text-left flex justify-between items-center focus:outline-none focus:ring-2 focus:ring-inset focus:ring-navy" onClick={() => toggleFaq(index)} aria-expanded={openIndex === index} data-id="element-221" data-mp="2z0owcx36jn27">
                <span className="font-semibold text-navy" data-id="element-222" data-mp="3826awb0xvgos">{faq.question}</span>
                {openIndex === index ? <ChevronUpIcon className="w-5 h-5 text-gray-500 flex-shrink-0" data-id="element-223" data-mp="3czoi9wzb5nuo" /> : <ChevronDownIcon className="w-5 h-5 text-gray-500 flex-shrink-0" data-id="element-224" data-mp="3htap38isixik" />}
              </button>

              {openIndex === index && <div className="px-6 pb-4 pt-0" data-id="element-225" data-mp="3mqjbjlaz1npm">
                  <p className="text-gray-600 text-sm leading-relaxed" data-id="element-226" data-mp="3qtftrawlnht1">
                    {faq.answer}
                  </p>
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}